import { calculateStats } from '../utils/stats.js';

/**
 * Initializes logic for Quick Selection and bulk modification selectors.
 */
export function initSelectors() {
    document.getElementById('set1_full_set').addEventListener('change', function () {
        applyFullSet('set1', this.value);
        const pb = document.getElementById('set1_gear_prebuild');
        if (pb) pb.value = '';
    });

    document.getElementById('set2_full_set').addEventListener('change', function () {
        applyFullSet('set2', this.value);
        const pb = document.getElementById('set2_gear_prebuild');
        if (pb) pb.value = '';
    });

    document.getElementById('set1_pit_set').addEventListener('change', function () {
        applyPitSet('set1', this.value);
        const pb = document.getElementById('set1_pit_prebuild');
        if (pb) pb.value = '';
    });

    document.getElementById('set2_pit_set').addEventListener('change', function () {
        applyPitSet('set2', this.value);
        const pb = document.getElementById('set2_pit_prebuild');
        if (pb) pb.value = '';
    });

    // Bulk Quality and Level Selectors
    const setupBulkSelectors = (prefix, type, slots) => {
        const nameSelect = document.getElementById(`${prefix}_bulk_${type}_name`);
        const qualitySelect = document.getElementById(`${prefix}_bulk_${type}_quality`);
        const levelSelect = document.getElementById(`${prefix}_bulk_${type}_level`);
        
        if (nameSelect) {
            nameSelect.addEventListener('change', function () {
                const val = this.value;
                
                const pb = document.getElementById(`${prefix}_${type}_prebuild`);
                if (pb) pb.value = '';
                
                slots.forEach(slot => {
                    const sel = document.querySelector(`select[name="${prefix}_${slot}_name"]`);
                    if (sel && !sel.disabled) {
                        sel.value = val;
                        sel.dispatchEvent(new Event('change'));
                    }
                });
            });
        }

        if (qualitySelect) {
            qualitySelect.addEventListener('change', function () {
                const val = this.value;
                slots.forEach(slot => {
                    const sel = document.querySelector(`select[name="${prefix}_${slot}_quality"]`);
                    if (sel && !sel.disabled) {
                        sel.value = val;
                        sel.dispatchEvent(new Event('change'));
                    }
                });
            });
        }

        if (levelSelect) {
            levelSelect.addEventListener('change', function () {
                const val = this.value;
                slots.forEach(slot => {
                    const sel = document.querySelector(`select[name="${prefix}_${slot}_level"]`);
                    if (sel && !sel.disabled) {
                        sel.value = val;
                        sel.dispatchEvent(new Event('change'));
                    }
                });
            });
        }
    };

    const gearSlots = ['helmet', 'chest', 'pants', 'weapon', 'ring', 'boots'];
    const pitSlots = ['saddle', 'chanfron', 'peytral'];

    setupBulkSelectors('set1', 'gear', gearSlots);
    setupBulkSelectors('set2', 'gear', gearSlots);
    setupBulkSelectors('set1', 'pit', pitSlots);
    setupBulkSelectors('set2', 'pit', pitSlots);
    
    const trinketSlots = ['trinket1', 'trinket2'];
    setupBulkSelectors('set1', 'trinket', trinketSlots);
    setupBulkSelectors('set2', 'trinket', trinketSlots);

    // Toggle logic for Set vs Pre-Builds vs Saved
    const setupUnifiedBulkToggles = (prefix) => {
        const radios = document.querySelectorAll(`input[name="${prefix}_bulk_mode"]`);
        
        const setGroups = {
            gear: document.getElementById(`${prefix}_gear_set_group`),
            trinket: document.getElementById(`${prefix}_trinket_set_group`),
            pit: document.getElementById(`${prefix}_pit_set_group`)
        };
        const prebuildGroups = {
            gear: document.getElementById(`${prefix}_gear_prebuild_group`),
            trinket: document.getElementById(`${prefix}_trinket_prebuild_group`),
            pit: document.getElementById(`${prefix}_pit_prebuild_group`)
        };
        const savedGroups = {
            gear: document.getElementById(`${prefix}_saved_group`),
            trinket: document.getElementById(`${prefix}_trinket_saved_group`),
            pit: document.getElementById(`${prefix}_pit_saved_group`)
        };
        const saveBtnContainer = document.getElementById(`${prefix}_save_btn_container`);

        const updateBulkUI = (mode) => {
            if (mode === 'saved') {
                // Hide sets and prebuild groups, show saved groups
                Object.values(setGroups).forEach(g => { if (g) g.style.display = 'none'; });
                Object.values(prebuildGroups).forEach(g => { if (g) g.style.display = 'none'; });
                Object.values(savedGroups).forEach(g => { if (g) g.style.display = ''; });
                if (saveBtnContainer) saveBtnContainer.style.display = '';
            } else if (mode === 'prebuild') {
                // Show prebuilds, hide sets, saved groups and save button
                Object.values(setGroups).forEach(g => { if (g) g.style.display = 'none'; });
                Object.values(prebuildGroups).forEach(g => { if (g) g.style.display = ''; });
                Object.values(savedGroups).forEach(g => { if (g) g.style.display = 'none'; });
                if (saveBtnContainer) saveBtnContainer.style.display = 'none';
            } else {
                // 'set' mode: Show sets, hide prebuilds, saved groups and save button
                Object.values(setGroups).forEach(g => { if (g) g.style.display = ''; });
                Object.values(prebuildGroups).forEach(g => { if (g) g.style.display = 'none'; });
                Object.values(savedGroups).forEach(g => { if (g) g.style.display = 'none'; });
                if (saveBtnContainer) saveBtnContainer.style.display = 'none';
            }
        };

        radios.forEach(radio => {
            radio.addEventListener('change', function() {
                updateBulkUI(this.value);
            });
            // Init with currently checked mode
            if (radio.checked) {
                updateBulkUI(radio.value);
            }
        });

        // Set up prebuild select listeners
        ['gear', 'trinket', 'pit'].forEach(type => {
            const prebuildSelect = document.getElementById(`${prefix}_${type}_prebuild`);
            if (prebuildSelect) {
                prebuildSelect.addEventListener('change', function() {
                    applyPreBuild(prefix, type, this.value);
                    
                    let setSelectId = '';
                    if (type === 'gear') setSelectId = `${prefix}_full_set`;
                    else if (type === 'pit') setSelectId = `${prefix}_pit_set`;
                    else if (type === 'trinket') setSelectId = `${prefix}_bulk_trinket_name`;
                    
                    const setSelect = document.getElementById(setSelectId);
                    if (setSelect) setSelect.value = '';
                });
            }
        });
    };

    setupUnifiedBulkToggles('set1');
    setupUnifiedBulkToggles('set2');
}

function applyPreBuild(setPrefix, sectionType, preBuildId) {
    if (!preBuildId) return;

    let slots = [];
    let logicalTarget = 'troops';
    if (sectionType === 'gear') {
        slots = ['helmet', 'chest', 'pants', 'weapon', 'ring', 'boots'];
        logicalTarget = 'troops';
    } else if (sectionType === 'trinket') {
        slots = ['trinket1', 'trinket2'];
        logicalTarget = 'troops'; 
    } else if (sectionType === 'pit') {
        slots = ['saddle', 'chanfron', 'peytral'];
        logicalTarget = 'pit';
    }

    let phase = 'attack';
    let troopType = 'Infantry';
    let rankMethod = 'standard';

    if (preBuildId === 'inf_atk_sop') { phase = 'attack'; troopType = 'Infantry'; }
    if (preBuildId === 'rng_atk_sop') { phase = 'attack'; troopType = 'Ranged'; }
    if (preBuildId === 'cav_atk_sop') { phase = 'attack'; troopType = 'Cavalry'; }
    if (preBuildId === 'inf_def_sop') { phase = 'defense'; troopType = 'Infantry'; }
    if (preBuildId === 'rng_def_sop') { phase = 'defense'; troopType = 'Ranged'; }
    if (preBuildId === 'cav_def_sop') { phase = 'defense'; troopType = 'Cavalry'; }
    if (preBuildId === 'troop_ms_sop') { phase = 'mssop'; troopType = 'Infantry'; } 

    if (preBuildId === 'drag_atk_v_drag') { 
        phase = 'attack'; troopType = 'Dragons'; logicalTarget = 'dragons'; 
    }
    if (preBuildId === 'drag_def') { 
        phase = 'defense'; troopType = 'Dragons'; logicalTarget = 'dragons'; 
        rankMethod = 'drag_def_only'; 
    }
    if (preBuildId === 'drag_def_troop_focus') { 
        phase = 'defense'; troopType = 'Dragons'; logicalTarget = 'dragons'; 
    }
    if (preBuildId === 'drag_ms_sop') { 
        phase = 'mssop'; troopType = 'Dragons'; logicalTarget = 'dragons'; 
    }

    const includeSop = true;
    
    slots.forEach((slot) => {
        let dataSlot = slot;
        if (slot.includes('trinket')) dataSlot = 'trinket';

        const items = window.GEAR_DATA[dataSlot] || [];
        
        let processedItems = items.map(item => {
            const stats = calculateStats(item, logicalTarget, phase, includeSop, troopType);
            let isClassMatch = false;
            
            if (phase === 'mssop') {
                const rawStats = item.stats || {};
                let hasMsStats = (rawStats["March Size"] || 0) > 0 || (rawStats["March Size Percent"] || 0) > 0 ||
                                 (rawStats["Single March Size vs Player"] || 0) > 0 || (rawStats["March Size vs SOP"] || 0) > 0 ||
                                 (rawStats["Dragon Max March Size"] || 0) > 0 || (rawStats["Dragon March Size vs Player"] || 0) > 0 ||
                                 (rawStats["Dragon March Size vs SOP"] || 0) > 0;
                isClassMatch = hasMsStats;
                if (item.set_name === 'Queen Mother') isClassMatch = true;
            } else if (logicalTarget === 'troops') {
                let matchClass = troopType === 'Dragons' ? 'Dragon' : troopType;
                isClassMatch = item.class === matchClass || !item.class || item.class === 'Troop' || item.class === 'SOP';
                
                if (!isClassMatch && phase === 'defense') {
                    const conflictingTypes = ['Infantry', 'Ranged', 'Cavalry'].filter(t => t !== troopType);
                    if (!conflictingTypes.includes(item.class)) isClassMatch = true;
                }
                if (sectionType === 'trinket') {
                    isClassMatch = item.class === troopType || item.class === 'Troop' || item.class === 'SOP' || !item.class;
                }
            } else if (logicalTarget === 'dragons') {
                isClassMatch = item.class === 'Dragon' || item.class === 'SOP' || !item.class;
            } else if (logicalTarget === 'pit') {
                isClassMatch = true; 
            }

            return { ...item, ...stats, isClassMatch };
        }).filter(item => {
            if (phase === 'mssop') return item.isClassMatch && (item.msBase > 0 || item.msPercent > 0);
            if (logicalTarget === 'troops') {
                const hasStats = item.totalSum > 0 || item.healthSum > 0 || item.mults.vInf > 0 || item.mults.vRng > 0 || item.mults.vCav > 0;
                return item.isClassMatch && hasStats;
            }
            if (logicalTarget === 'dragons') {
                if (phase === 'attack') return item.dAtkSum > 0;
                if (phase === 'defense') return item.dDefSum > 0 || item.dHealthSum > 0;
            }
            if (logicalTarget === 'pit') {
                if (phase === 'attack') return item.pDragTroopAtk > 0 || item.pMults.vInf > 0 || item.pMults.vRng > 0 || item.pMults.vCav > 0 || item.pDragAtkBase > 0;
                if (phase === 'defense') return item.pDragDH > 0 || item.pMults.vInf > 0 || item.pMults.vRng > 0 || item.pMults.vCav > 0 || item.pDragAtkBase > 0;
            }
            return false;
        });

        processedItems.forEach(item => {
            if (phase === 'mssop') {
                // Sorting logic now exactly matches rankings.js
            } else if (logicalTarget === 'troops') {
                let baseStat = item.totalSum;
                const calcScore = (m) => (baseStat / 100 * m) + baseStat + m;
                const sInf = calcScore(item.mults.vInf);
                const sRng = calcScore(item.mults.vRng);
                const sCav = calcScore(item.mults.vCav);

                let wInf = 1.0, wRng = 1.0, wCav = 1.0;
                if (phase === 'defense') {
                    if (troopType === 'Infantry') { wRng = 1.7; wCav = 0.3; }
                    else if (troopType === 'Ranged') { wCav = 1.7; wInf = 0.3; }
                    else if (troopType === 'Cavalry') { wInf = 1.7; wRng = 0.3; }
                } else if (phase === 'attack') {
                    if (troopType === 'Infantry') { wCav = 1.7; wRng = 0.3; }
                    else if (troopType === 'Ranged') { wInf = 1.7; wCav = 0.3; }
                    else if (troopType === 'Cavalry') { wRng = 1.7; wInf = 0.3; }
                }
                
                let rankScore = ((sInf * wInf) + (sRng * wRng) + (sCav * wCav)) / 3;
                let mCount = (item.mults.vInf > 0 ? 1 : 0) + (item.mults.vRng > 0 ? 1 : 0) + (item.mults.vCav > 0 ? 1 : 0);
                let mBonus = (baseStat * 0.25) * mCount;
                let hBonus = phase === 'defense' ? item.healthSum : 0;
                item.rankScore = rankScore + mBonus + hBonus;
            } else if (logicalTarget === 'dragons') {
                if (phase === 'attack') item.rankScore = item.dAtkSum;
                if (phase === 'defense') {
                    if (rankMethod === 'drag_def_only') item.rankScore = item.dDefSum;
                    else {
                        // 'drag_def_troop_focus' logic
                        if (item.dDefSum <= 0 || (item.totalSum + item.healthSum) <= 0) {
                            item.rankScore = -1; // Explicitly enforce that all pieces here must yield Dragon Defense AND Troop Defense
                        } else {
                            let troopDH = item.totalSum + item.healthSum;
                            let dragDvd = item.dDefSum + item.dHealthSum;
                            // Threshold Logic: If Troop D/H is robust (>= 150), prioritize it heavily.
                            if (troopDH >= 150) {
                                item.rankScore = (troopDH * 1000) + dragDvd;
                            } else {
                                item.rankScore = (dragDvd * 1000) + troopDH;
                            }
                        }
                    }
                }
            } else if (logicalTarget === 'pit') {
                if (phase === 'attack') item.rankScore = item.pDragTroopAtk;
                if (phase === 'defense') item.rankScore = item.pDragDH;
            }
        });

        if (phase === 'mssop') {
            processedItems.sort((a, b) => {
                if (b.msBase !== a.msBase) return b.msBase - a.msBase;
                return b.msPercent - a.msPercent;
            });
        } else {
            processedItems.sort((a, b) => b.rankScore - a.rankScore);
        }

        if (processedItems.length > 0) {
            const topItem = processedItems[0];
            const selectElement = document.querySelector(`select[name="${setPrefix}_${slot}_name"]`);
            if (selectElement) {
                selectElement.value = topItem.name;
                selectElement.dispatchEvent(new Event('change'));
            }
        }
    });

    const qualityVal = document.getElementById(`${setPrefix}_bulk_${sectionType}_quality`)?.value;
    const levelVal = document.getElementById(`${setPrefix}_bulk_${sectionType}_level`)?.value;

    if (qualityVal || levelVal) {
        slots.forEach(slot => {
            if (qualityVal) {
                const qSel = document.querySelector(`select[name="${setPrefix}_${slot}_quality"]`);
                if (qSel && !qSel.disabled) { qSel.value = qualityVal; qSel.dispatchEvent(new Event('change')); }
            }
            if (levelVal) {
                const lSel = document.querySelector(`select[name="${setPrefix}_${slot}_level"]`);
                if (lSel && !lSel.disabled) { lSel.value = levelVal; lSel.dispatchEvent(new Event('change')); }
            }
        });
    }
}


function applyFullSet(setPrefix, setName) {
    if (!setName) return;

    const slots = ['helmet', 'chest', 'pants', 'weapon', 'ring', 'boots', 'trinket1', 'trinket2'];

    slots.forEach(slot => {
        const dataSlot = slot.includes('trinket') ? 'trinket' : slot;
        const itemsInSlot = window.GEAR_DATA[dataSlot] || [];
        const matchingItem = itemsInSlot.find(item => item.set_name === setName);

        if (matchingItem) {
            const selectElement = document.querySelector(`select[name="${setPrefix}_${slot}_name"]`);
            if (selectElement) {
                selectElement.value = matchingItem.name;
                selectElement.dispatchEvent(new Event('change'));
            }
        }
    });

    const qualityVal = document.getElementById(`${setPrefix}_bulk_gear_quality`)?.value;
    const levelVal = document.getElementById(`${setPrefix}_bulk_gear_level`)?.value;

    if (qualityVal || levelVal) {
        slots.filter(s => !s.includes('trinket')).forEach(slot => {
            if (qualityVal) {
                const qSel = document.querySelector(`select[name="${setPrefix}_${slot}_quality"]`);
                if (qSel && !qSel.disabled) {
                    qSel.value = qualityVal;
                    qSel.dispatchEvent(new Event('change'));
                }
            }
            if (levelVal) {
                const lSel = document.querySelector(`select[name="${setPrefix}_${slot}_level"]`);
                if (lSel && !lSel.disabled) {
                    lSel.value = levelVal;
                    lSel.dispatchEvent(new Event('change'));
                }
            }
        });
    }
}

function applyPitSet(setPrefix, setName) {
    if (!setName) return;

    const slots = ['saddle', 'chanfron', 'peytral'];

    slots.forEach(slot => {
        const itemsInSlot = window.GEAR_DATA[slot] || [];
        const matchingItem = itemsInSlot.find(item => item.set_name === setName);

        if (matchingItem) {
            const selectElement = document.querySelector(`select[name="${setPrefix}_${slot}_name"]`);
            if (selectElement) {
                selectElement.value = matchingItem.name;
                selectElement.dispatchEvent(new Event('change'));
            }
        }
    });

    const qualityVal = document.getElementById(`${setPrefix}_bulk_pit_quality`)?.value;
    const levelVal = document.getElementById(`${setPrefix}_bulk_pit_level`)?.value;

    if (qualityVal || levelVal) {
        slots.forEach(slot => {
            if (qualityVal) {
                const qSel = document.querySelector(`select[name="${setPrefix}_${slot}_quality"]`);
                if (qSel && !qSel.disabled) {
                    qSel.value = qualityVal;
                    qSel.dispatchEvent(new Event('change'));
                }
            }
            if (levelVal) {
                const lSel = document.querySelector(`select[name="${setPrefix}_${slot}_level"]`);
                if (lSel && !lSel.disabled) {
                    lSel.value = levelVal;
                    lSel.dispatchEvent(new Event('change'));
                }
            }
        });
    }
}
